// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { Dataset } from "./Dataset";
import { instanceOfDataset, DatasetFromJSON, DatasetFromJSONTyped, DatasetToJSON } from "./Dataset";
import type { RanaFile } from "./RanaFile";
import {
  instanceOfRanaFile,
  RanaFileFromJSON,
  RanaFileFromJSONTyped,
  RanaFileToJSON,
} from "./RanaFile";

/**
 * @type Create2dFloodModelInputElevation
 *
 * @export
 */
export type Create2dFloodModelInputElevation = Dataset | RanaFile;

export function Create2dFloodModelInputElevationFromJSON(
  json: any
): Create2dFloodModelInputElevation {
  return Create2dFloodModelInputElevationFromJSONTyped(json, false);
}

export function Create2dFloodModelInputElevationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Create2dFloodModelInputElevation {
  if (json == null) {
    return json;
  }
  if (typeof json !== "object") {
    return json;
  }
  if (instanceOfDataset(json)) {
    return DatasetFromJSONTyped(json, true);
  }
  if (instanceOfRanaFile(json)) {
    return RanaFileFromJSONTyped(json, true);
  }
  return {} as any;
}

export function Create2dFloodModelInputElevationToJSON(json: any): any {
  return Create2dFloodModelInputElevationToJSONTyped(json, false);
}

export function Create2dFloodModelInputElevationToJSONTyped(
  value?: Create2dFloodModelInputElevation | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }
  if (typeof value !== "object") {
    return value;
  }
  if (instanceOfDataset(value)) {
    return DatasetToJSON(value as Dataset);
  }
  if (instanceOfRanaFile(value)) {
    return RanaFileToJSON(value as RanaFile);
  }
  return {};
}
